import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./EgateL.css";
import LandingPageHeader from "./LandingPageHeader";
import LandingPageHero from "./LandingPageHero";
import ExamPathSection from "./ExamPathSection";
import WhyChooseUs from "./WhyChooseUs";
import LandingPageFooter from "../components/UG/Footer2";

export const Egate = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [showUGExamExplore, setShowUGExamExplore] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const handledRouteScrollRef = useRef(false);

  // Refs for sections
  const heroRef = useRef(null);
  const examRef = useRef(null);
  const whyChooseRef = useRef(null);
  const exploreRef = useRef(null); // <-- new ref for the actual Explore list

  const scrollWithHeaderOffset = (element, extraOffset = 24) => {
    if (!element) return;

    const header = document.querySelector(".header");
    const headerHeight = header?.offsetHeight ?? 0;
    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
    const offsetTop = Math.max(elementTop - headerHeight - extraOffset, 0);

    window.scrollTo({
      top: offsetTop,
      behavior: "smooth",
    });
  };

  // Scroll handlers
  const scrollToHero = () => scrollWithHeaderOffset(heroRef.current, 12);

  const scrollToExams = () => {
    setShowUGExamExplore(false); // show the ExamPathSection + ExamExplore

    // Wait for ExamExplore to mount, then scroll to the actual Explore list
    setTimeout(() => {
      if (exploreRef.current) {
        scrollWithHeaderOffset(exploreRef.current);
        return;
      }

      // fallback to examRef if exploreRef not present
      if (examRef.current) {
        scrollWithHeaderOffset(examRef.current);
      }
    }, 100);
  };

  const scrollToWhyChooseUs = () => {
    const whyChooseSection =
      whyChooseRef.current?.querySelector("#why-choose-us") ?? whyChooseRef.current;

    scrollWithHeaderOffset(whyChooseSection);
  };

  useEffect(() => {
    const targetSection = location.state?.scrollTo;

    if (!targetSection) {
      return;
    }

    handledRouteScrollRef.current = true;

    const scrollMap = {
      home: scrollToHero,
      exams: scrollToExams,
      aboutus: scrollToWhyChooseUs,
    };

    setTimeout(() => {
      scrollMap[targetSection]?.();
      navigate(location.pathname, { replace: true, state: null });
    }, 100);
  }, [location.pathname, location.state, navigate]);

  // Popup handlers
  const handleComingSoonClick = (e) => {
    e.preventDefault();
    setShowPopup(true);
  };
  const closePopup = () => setShowPopup(false);

  useEffect(() => {
    if (!location.state?.scrollTo && !handledRouteScrollRef.current) {
      window.scrollTo(0, 0);
    }
  }, [location.state]);

  return (
    <div className="Ug_Home_page_main_container">
      <div className="Ug_Home_page_Sub_container">
        {/* Header */}
        <LandingPageHeader
          onHomeClick={scrollToHero}
          onExamsClick={scrollToExams}
          onAboutUsClick={scrollToWhyChooseUs}
        />

        {/* Hero Section */}
        <div ref={heroRef}>
          <LandingPageHero onExploreExamsClick={scrollToExams} />
        </div>

        {/* Exams Section */}
        <div ref={examRef}>
          <ExamPathSection
            showUGExamExplore={showUGExamExplore}
            setShowUGExamExplore={setShowUGExamExplore}
            exploreRef={exploreRef} // <-- pass ref down
          />
        </div>

        {/* Why Choose Us Section */}
        <div ref={whyChooseRef}>
          <WhyChooseUs />
        </div>

        {/* Footer */}
        <LandingPageFooter />
      </div>

      {/* Coming Soon Popup */}
      {showPopup && (
        <div className="popup-overlayPgcourses">
          <div className="popupPgcourses">
            <h2>Coming Soon</h2>
            <p>This course will be available soon. Stay tuned!</p>
            <button onClick={closePopup}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};
